import styled from 'vue-styled-components'

export default styled.div`
    & .group-item {
        display: flex;
        & label {
            font-weight: bold;
            margin-right: 5px;
        }
    }
`;